/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RemoteMcpServer,
  RemoteMcpServer$inboundSchema,
} from "./remotemcpserver.js";

/**
 * Result type for listing remote MCP servers
 */
export type ListServersResult = {
  remoteMcpServers: Array<RemoteMcpServer>;
};

/** @internal */
export const ListServersResult$inboundSchema: z.ZodMiniType<
  ListServersResult,
  unknown
> = z.pipe(
  z.object({
    remote_mcp_servers: z.array(RemoteMcpServer$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "remote_mcp_servers": "remoteMcpServers",
    });
  }),
);

export function listServersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListServersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListServersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListServersResult' from JSON`,
  );
}
